import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { IFiltroRenegociacaoAnalise } from "../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";

interface IFiltroAprovacaoRenegociacao {
    filter: IFiltroRenegociacaoAnalise | undefined;
    FILTRO_GESTAO_APROVACAO_RENEGOCIACAO: string | null;
    handleDateChange: (formData: IFiltroRenegociacaoAnalise) => void;
    filtroInicial: IFiltroRenegociacaoAnalise;
    setFilter: (filter: IFiltroRenegociacaoAnalise) => void;
}
export default function FiltroAprovacaoRenegociacao(
    props: IFiltroAprovacaoRenegociacao
) {
    const FormMethods = useForm();

    const { register, handleSubmit, reset } = FormMethods;

    return (
        <>
            <StickyToolbar
                active={!!props.FILTRO_GESTAO_APROVACAO_RENEGOCIACAO}
            >
                <FormProvider {...FormMethods}>
                    <form
                        className="form-group row"
                        onSubmit={handleSubmit(props.handleDateChange)}
                    >
                        <div className="col-12 mt-3">
                            <label>Dt. Aprovação Inicio</label>
                            <input
                                className="form-control"
                                name="DT_APROVACAO_INICIO"
                                defaultValue={props.filter?.DT_APROVACAO_INICIO}
                                ref={register()}
                                type="date"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Dt. Aprovação Fim</label>
                            <input
                                className="form-control"
                                name="DT_APROVACAO_FIM"
                                defaultValue={props.filter?.DT_APROVACAO_FIM}
                                ref={register()}
                                type="date"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Usuário Responsável</label>
                            <LazySelect
                                className="form-control"
                                name="ID_USUARIO_RESPONSAVEL"
                                ref={register()}
                                controller={ListarUsuariosController}
                                filter={(u) => u.FL_ATIVO}
                                getDS={(u) => u.DS_NOME}
                                getKeyValue={(u) => u.ID_USUARIO}
                                defaultValue={
                                    props.filter?.ID_USUARIO_RESPONSAVEL
                                }
                                // setValue={setValue}
                            >
                                <option></option>
                            </LazySelect>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Status</label>
                            <select
                                className="form-control"
                                name="DS_STATUS"
                                ref={register()}
                                defaultValue={props.filter?.DS_STATUS}
                            >
                                <option></option>
                                <option>APROVADO</option>
                                <option>REPROVADO</option>
                                <option>FORA DO PRAZO</option>
                                <option>AGUARDANDO APROVAÇÃO</option>
                            </select>
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_A_NEGATIVAR"
                                    );
                                    props.setFilter(props.filtroInicial);
                                    reset(props.filtroInicial);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
